import { Label, Switch, Text } from '@/design-system/components/ui';

interface Props {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
}

const SWITCH_ID = 'crypto-triggers-switch';

export const CryptoTriggersToggle = ({ checked, onCheckedChange }: Props) => {
  return (
    <div className="tw:flex tw:flex-row tw:justify-between tw:items-center tw:gap-6 tw:border tw:border-dashed tw:border-border tw:rounded-xl tw:px-5 tw:py-4">
      <Text variant="body-md" color="muted">
        {checked
          ? 'Shown below: onchain events, token holdings, DeFi protocols and social quests.'
          : 'Looking for onchain events, token holders, DeFi protocols or social quests?'}
      </Text>
      <div className="tw:flex tw:flex-row tw:items-center tw:gap-3 tw:shrink-0">
        <Label htmlFor={SWITCH_ID} className="tw:cursor-pointer tw:whitespace-nowrap">
          Crypto &amp; quest triggers
        </Label>
        <Switch id={SWITCH_ID} checked={checked} onCheckedChange={onCheckedChange} />
      </div>
    </div>
  );
};
